// src/components/Surveys/SurveyList.jsx

import { useState, useEffect } from 'react';
import API from '../../api/axiosConfig';
import SurveyForm from './SurveyForm';
import TestPreLoader from '../../pages/TestPreLoader/TestPreLoader';
import { getCurrentPeriod } from "../../Utils/getCurrentPeriod";

const NPS_BADGE = {
  promoter:  { label: 'مروّج',   bg: '#dbeafe', color: '#1d4ed8' },
  passive:   { label: 'محايد',   bg: '#ede9fe', color: '#7c3aed' },
  detractor: { label: 'منتقد', bg: '#ccfbf1', color: '#0f766e' },
};

const STARS = (score) => score
  ? '★'.repeat(score) + '☆'.repeat(5 - score)
  : '—';

const SurveyList = ({ period = getCurrentPeriod() }) =>  {
  const [data,     setData]     = useState({ data: [], stats: {}, meta: {} });
  const [loading,  setLoading]  = useState(true);
  const [showForm, setShowForm] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const res = await API.get('/surveys', { params: { period } });
      setData(res.data);
    } finally {
      setLoading(false);
    }
  };

  const getNpsCategory = (row) => {
  if (row.nps_category) return row.nps_category; // ← من الـ API
  if (row.nps_score === null || row.nps_score === undefined) return null;
  if (row.nps_score >= 9) return 'promoter';
  if (row.nps_score >= 7) return 'passive';
  return 'detractor';
};

  useEffect(() => { load(); }, [period]);

  const cardStyle = {
  backgroundColor: 'var(--background-color)',
  border: '1px solid var(--border-color)',
  borderRadius: '12px',
  padding: '16px',
  textAlign: 'center',
  boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
};
 

  const stats = data.stats ?? {};

  return (
    loading ? <TestPreLoader /> :
    <div style={{ padding: '24px', width:"80%", margin: '0 auto' }} dir="rtl">

      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4" >
        <div>
          <h2 style={{ color: 'var(--text-color)', fontWeight: 600, marginBottom: 4 }}>استبيانات الرضا</h2>
          <p style={{ color: 'var(--text-muted, #6b7280)', fontSize: 13, margin: 0 }}>الفترة: {period}</p>
        </div>
        <button
          onClick={() => setShowForm(s => !s)}
         style={{
            backgroundColor: '#0f766e',
            color: '#fff',
            border: 'none',
            borderRadius: '10px',
            padding: '8px 18px',
            fontSize: 14,
            cursor: 'pointer',
          }}
        >
          {showForm ? 'إغلاق' : '+ استبيان جديد'}
        </button>
      </div>

      {/* Form */}
      {showForm && (
        <div className="mb-6">
          <SurveyForm
            period={period}
            onSuccess={() => { setShowForm(false); load(); }}
          />
        </div>
      )}

      {/* Stats Cards */}
      <div className="row g-3 mb-4" >
        {/* <div className="rounded-xl border border-gray-100 p-4 text-center shadow-sm" style={{ backgroundColor: '--var(--background-color)' }}>
          <p className="text-2xl font-bold text-gray-800">{stats.total ?? 0}</p>
          <p className="text-xs text-gray-400 mt-1">إجمالي الاستبيانات</p>
        </div>
        <div className="rounded-xl border border-gray-100 p-4 text-center shadow-sm" style={{ backgroundColor: '--var(--background-color)' }}>
          <p className="text-2xl font-bold text-yellow-500">
            {stats.avg_satisfaction ?? '—'}
          </p>
          <p className="text-xs text-gray-400 mt-1">متوسط الرضا / 5</p>
        </div>
        <div className={`rounded-xl border p-4 text-center shadow-sm
          ${stats.nps >= 0 ? 'bg-green-50 border-green-100' : 'bg-red-50 border-red-100'}`}>
          <p className={`text-2xl font-bold
            ${stats.nps >= 0 ? 'text-green-600' : 'text-red-500'}`}>
            {stats.nps !== null && stats.nps !== undefined ? stats.nps : '—'}
          </p>
          <p className="text-xs text-gray-400 mt-1">مؤشر NPS</p>
        </div> */}
        {[
          { label: 'إجمالي الاستبيانات',  value: stats.total ?? 0 ,   color: '#0f766e' },
          { label: 'متوسط الرضا',     value: stats.avg_satisfaction ?? '—',   color: '#1f2937' },
          { label: 'مؤشر NPS',     value: stats.nps !== null && stats.nps !== undefined ? stats.nps : '—',   color: stats.nps >= 0 ? '#22c55e' : 'text-red-500', color: '#7c3aed' },
        ].map(s => (
          <div className="col-4" key={s.label}>
            <div style={cardStyle}>
              <p style={{ fontSize: 24, fontWeight: 700, color: s.color, margin: 0 }}>{s.value}</p>
              <p style={{ fontSize: 12, color: 'var(--text-muted, #6b7280)', marginTop: 4 }}>{s.label}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Table */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: '48px', color: 'var(--text-muted, #9ca3af)' }}>جاري التحميل...</div>
      ) : data.data.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '48px', color: 'var(--text-muted, #9ca3af)', backgroundColor: 'var(--background-color)', borderRadius: 12 }}>
          <p className="text-4xl mb-2">📋</p>
          <p>لا توجد استبيانات لهذه الفترة</p>
        </div>
      ) : (
        <div style={{ backgroundColor: 'var(--background-color)', borderRadius: 12, overflow: 'hidden', border: '1px solid var(--border-color)' }}>
          <table className="table mb-0" style={{ color: 'var(--text-color)' }} >
            <thead style={{ backgroundColor: 'var(--border-color)', color: 'var(--text-color)' }}>
              <tr></tr>
              <tr >
                <th style={{ textAlign: 'center', padding: '12px 16px' }}>المستفيد</th>
                <th style={{ textAlign: 'center', padding: '12px 16px' }}>الرضا</th>
                <th style={{ textAlign: 'center', padding: '12px 16px' }}>NPS</th>
                <th style={{ textAlign: 'center', padding: '12px 16px' }}>التصنيف</th>
                <th style={{ textAlign: 'center', padding: '12px 16px' }}>التاريخ</th>
              </tr>
            </thead>
            <tbody>
              {data.data.map(row => {
                const badge = NPS_BADGE[getNpsCategory(row)];
                return (
                  <tr key={row.id} style={{ borderTop: '1px solid var(--border-color)' }}>
                    <td className="px-4 py-3 text-gray-700 font-medium">
                      {row.humancase_name ?? 'غير محدد'}
                    </td>
                    <td className="px-4 py-3 text-center text-yellow-500 text-base">
                      {STARS(row.satisfaction_score)}
                    </td>
                    <td className="px-4 py-3 text-center font-semibold text-gray-700">
                      {row.nps_score ?? '—'}
                    </td>
                    <td className="px-4 py-3 text-center">
                      {badge ? (
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${badge.color}`}>
            {badge.label}
          </span>
        ) : '—'}
                    </td>
                    <td className="px-4 py-3 text-gray-400 text-xs">
                      {row.submitted_at
                        ? new Date(row.submitted_at).toLocaleDateString('ar-SA')
                        : '—'}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SurveyList;